import photo1 from '../../../shared/assets/photo/woman/1.jpg';
import photo2 from '../../../shared/assets/photo/woman/10.jpg';
import photo3 from  '../../../shared/assets/photo/woman/11.jpg';
import photo4 from  '../../../shared/assets/photo/woman/12.jpg';
import photo5 from '../../../shared/assets/photo/woman/13.jpg';
import photo6 from '../../../shared/assets/photo/woman/14.jpg';
import photo7 from '../../../shared/assets/photo/woman/15.jpg';
import photo8 from  '../../../shared/assets/photo/woman/16.jpg';
import photo9 from  '../../../shared/assets/photo/woman/17.jpg';
import photo10 from  '../../../shared/assets/photo/woman/18.jpg';
import photo11 from '../../../shared/assets/photo/woman/19.jpg';
import photo12 from  '../../../shared/assets/photo/woman/2.jpg';


export const womanData = [
    {
        id: 1,
        photo: photo1
    },
    {
        id: 2,
        photo: photo2
    },
    {
        id: 3,
        photo: photo3
    },
    {
        id: 4,
        photo: photo4
    },
    {
        id: 5,
        photo: photo5
    },
    {
        id: 6,
        photo: photo6
    },
    {
        id: 7,
        photo: photo7
    },
    {
        id: 8,
        photo: photo8
    },
    {
        id: 9,
        photo: photo9
    },
    {
        id: 10,
        photo: photo10
    },
    {
        id: 11,
        photo: photo11
    },
    {
        id: 12,
        photo: photo12
    },
];